// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectListWarehouse .MuiInputLabel-outlined,.ccl_reason .MuiInputLabel-outlined{\n    z-index: 1;\n    transform: translate(14px, 14px) scale(0.9) !important;\n    pointer-events: none;\n}\n.selectListWarehouse .MuiInputLabel-outlined.MuiInputLabel-shrink,.ccl_reason .MuiInputLabel-outlined.MuiInputLabel-shrink{\n    transform: translate(14px, -6px) scale(0.75) !important;\n}", ""]);
// Exports
module.exports = exports;
